<form class="grid-container grid-3" [formGroup]="formGroup">
    <ui-form-field class="grid-row-1" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.X_AXIS' | translate">
        <ui-select
            formControlName="xAxisMeasureCode"
            labelField="name"
            valueField="measureCode"
            [options]="availableMeasures"
            [required]="true"
            [disabled]="!availableMeasures?.length || disabled"
        />
    </ui-form-field>

    <ui-form-field class="grid-row-1" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.Y_AXIS' | translate">
        <ui-select
            formControlName="yAxisMeasureCode"
            labelField="name"
            valueField="measureCode"
            [options]="availableMeasures"
            [required]="true"
            [disabled]="!availableMeasures?.length || disabled"
        />
    </ui-form-field>

    <ui-form-field class="grid-row-1" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.POINT_SIZE' | translate">
        <ui-select
            formControlName="pointSizeMeasureCode"
            labelField="name"
            valueField="measureCode"
            [options]="availableMeasures"
            [required]="false"
            [clearable]="true"
            [disabled]="!availableMeasures?.length || disabled"
        />
    </ui-form-field>

    <ui-form-field class="grid-row-2" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.GROUP_BY' | translate">
        <ui-select
            formControlName="groupByDimensionCode"
            labelField="name"
            valueField="dimensionCode"
            [options]="dimensions$ | async"
            [disabled]="!(dimensions$ | async)?.length || disabled"
            [required]="true"
        />
    </ui-form-field>

    @if (isMeasureSegmentable$ | async) {
        <ui-form-field class="grid-row-2" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.SEGMENTATION' | translate">
            <ui-select
                formControlName="segmentationDimensionCode"
                labelField="name"
                valueField="dimensionCode"
                [options]="dimensions$ | async"
                [disabled]="!(dimensions$ | async)?.length || disabled"
                [required]="false"
                [clearable]="true"
            />
        </ui-form-field>
    }
</form>
